export default __webpack_public_path__ + "static/media/digi-locker.1ec317fa.webp";